export enum Modes {
  Add = 0,
  Edit = 1,
  Details = 2,
}

export enum OrderStatus {
  Open = 'open',
  Complete = 'complete',
  Cancelled = 'cancelled',
  Unclaimed = 'unclaimed',
}
